export default __webpack_public_path__ + "static/media/power.2c201894.png";